document.addEventListener('DOMContentLoaded', function() {
    const divAlerta = document.querySelector('.cont-alertas');
    if(divAlerta){
        const alertasIniciales = Array.from(divAlerta.children);
        const btnCerrarAlerta = divAlerta.querySelectorAll('#btn-cerrar-alerta');
        btnCerrarAlerta.forEach(cerrarAlerta => {
            cerrarAlerta.addEventListener('click', function() {
                let tiposAlertas = ['.alerta-verde', '.alerta-roja'];
                const alerta = this.closest(tiposAlertas);
                if (alerta) {
                    alerta.remove(); // Elimina solo el div 'alerta-roja' específico
                }
            });
        });
        setTimeout(() => {
            alertasIniciales.forEach(alerta => alerta.remove());
            if (!divAlerta.children.length) {
                divAlerta.classList.remove("show--alert");
            }
        }, 7000); // Cerrado automático solo de las alertas renderizadas por PHP.
    }
});
